//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ControllerMixin from '@app/Filters/mixins/ControllerMixin'

export default {
  mixins: [ControllerMixin],
  data() {
    return {
      activeState: false,
      height: 0,
    }
  },
  methods: {
    toggleFilters(fn) {
      this.activeState = !this.activeState
      this.height = this.activeState ? 'initial' : 0
      fn()
    },
    openModal(key) {
      this.$modal.show(key)
      // const app = document.getElementById('app')
      // app.dataset.blocked = true
    },
  },
}

